import * as THREE from 'three'

import Canvas3d from 'root/animator/presets/canvas3d'
import Camera from './extensions/Camera'
import CustomStats from './extensions/Stats'
import Controls from './extensions/Controls'
import Controller from './Controller'
import Composer from './Composer'

class Canvas extends Canvas3d {
    camera: any

    stats: any
    controls: any
    controller: any

    composer

    constructor(parent, canvas, controllerContext) {
        super(parent, canvas)
        this.camera = new Camera(this.scene)
        // this.stats = new CustomStats(this.parent)
        this.controls = new Controls( this.camera.instance, this.canvas )
        this.controller = new Controller(this.scene, this.canvas, controllerContext)

        this.renderer.shadowMap.enabled = true
        this.renderer.shadowMap.type = THREE.VSMShadowMap

        this.scene.background = new THREE.Color(0x000000)
        this.scene.fog = new THREE.Fog(0x000000, 0, 15)
        // console.log(this.scene)

        this.composer = new Composer(this.renderer, this.scene, this.camera.instance)

        this.toRender(() => {
            // this.stats.render()
            this.controller.render()
            this.composer.render()
        })

        this.toResize(() => {
            this.camera.resize()
            this.controller.resize()
            this.composer.resize()
        })
    }


    unmount() {
        this.controller.unmount()
    }
}

export default Canvas